import React, { useContext, useState, useEffect, useRef } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';

import Typography from '@mui/material/Typography';

import SidebarAdmin from './sidebaradmin';
import FilterListIcon from '@mui/icons-material/FilterList';
import VisibilityIcon from '@mui/icons-material/Visibility';

import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Navigate,
  Link,
  NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import Application from '../application';
import { getApplicationList, getDownloadConsentForms, getDownloadphysicianForms, getLocationList } from '../../actions/admin.actions';
import { AppContext } from '../../context';
import secureLocalStorage from "react-secure-storage";

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';

import DownloadIcon from '@mui/icons-material/Download';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import axios from 'axios';
import { useSelector } from 'react-redux';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function ApplicationList() {
  const [manageapplicationList, setManagApplicationsList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const { storage } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [loadernew, setLoaderNew] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [loaderId, setLoaderId] = useState('');
  const [searchType, setSearchType] = useState('employeeid');
  const [pageLoader, setPageLoader] = useState(false);
  const [loginval, setloginval] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Student ID');
  const [searchBy, setSearchBy] = useState('student_id');
  const [searchValue, setSearchValue] = useState('');
  const [searchLocValue, setSearchLocValue] = useState(null);
  const [searchstatusValue, setSearchstatusValue] = useState(null);

  const [searchstatusLocValue, setSearchstatusLocValue] = useState(null);
  const [searchGradeValue, setSearchGradeValue] = useState('');
  const [searchGradeSerValue, setSearchGradeSerValue] = useState('');
  const [checkUnderstand, setCheckUnderstand] = useState(false);
  const [ipuser, setIpuser] = useState(null);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  //const [locations, setLocations] = useState([]);
  const { locations } = useSelector(state => state.userdata);
  const sttausList = [
    { lable: 'Approved', value: 'Approved' },
    { lable: 'Pending', value: 'Pending' },
    { lable: 'Rejected', value: 'Rejected' },
  ]

  const GradeList = [
    { lable: 'High School', value: 'High School' },
    { lable: 'Middle School', value: 'Middle School' },
    // { lable: 'Primary School', value: 'Primary School' },
  ]
  const GradeHighList = [
    { lable: 12, value: 12 },
    { lable: 11, value: 11 },
    { lable: 10, value: 10 },
    { lable: 9, value: 9 },
  ]


  const GradeMiddleList = [
    { lable: 12, value: 12 },
    { lable: 11, value: 11 },
    { lable: 10, value: 10 },
    { lable: 9, value: 9 },
    { lable: 8, value: 8 },
    { lable: 7, value: 7 },
    { lable: 6, value: 6 },
  ]

  const GradePrimaryList = [
    { lable: 5, value: 5 },
    { lable: '4F', value: '4F' },
    { lable: 4, value: 4 },
    { lable: '3F', value: '3F' },
    { lable: 3, value: 3 },
    { lable: 2, value: 2 },
    { lable: 1, value: 1 },
    { lable: 'KK', value: 'KK' },
  ]
  React.useEffect(() => {
    if (document.body.classList.contains('adminbody_bg')) {
      document.body.classList.remove('body');
    }
    document.body.classList.add('adminbody_bg');

    // getLocationList({all: 1}).then((res) => {
    //   setLocations(res.data.data.locations);
    // }).catch((error) => {
    //   console.log(error);
    // });
  }, []);

  useEffect(() => {
    loadApplications();
  }, [pageNo, perPage, searchBy, searchValue]);

  const loadApplications = () => {

    setFirstLoading(true);

    getApplicationList({ "pageNo": pageNo, "perPage": perPage, search_by: searchBy, search: searchValue })

      .then(res => {
        setManagApplicationsList(res.data.data);
        setTotalCount(res.data.pagination.totalCount);
        setTotalPage(res.data.pagination.totalPage);
        setFirstLoading(false);
      });



  }
  const handleDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/downloadforms/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `parent_consent_forms_${applItem.stuid}.zip`);
      })
  }

  const handlePhysicianDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/application/download-physician-form/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `physician_forms_${applItem.stuid}.zip`);
      })
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }

  const handleDownload = (fileName) => {
    const link = document.createElement('a');
    link.href = storage[0].imageEndUrl + fileName;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  }

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);
  };

  const changePage = (page) => {
    var usernew = JSON.parse(secureLocalStorage.getItem('nursedata'));
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setFirstLoading(true);
    setPageNo(page);



  }
  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    setPageNo(1);
  }

  const handleColumnClick = (type) => {
    setSearchValue('');
    let placeholder = '';
    document.getElementById('location_idsearch').style.display = 'none';
    document.getElementById('text_idsearch').style.display = 'block';
    document.getElementById('status_idsearch').style.display = 'none';
    switch (type) {
      case 'location':
        document.getElementById('text_idsearch').style.display = 'none';
        document.getElementById('status_idsearch').style.display = 'none';

        document.getElementById('location_idsearch').style.display = 'block';
        placeholder = 'Location';
        break;
      case 'status':
        document.getElementById('text_idsearch').style.display = 'none';
        document.getElementById('location_idsearch').style.display = 'none';

        document.getElementById('status_idsearch').style.display = 'block';
        placeholder = 'status';
        break;
      case 'student_id':
        placeholder = 'Student ID ';
        break;
      case 'student_name':
        placeholder = 'Student First Name';
        break;
      case 'grade':
        placeholder = 'Grade';
        break;
      default:
        placeholder = 'Location';
        break;
    }
    setSearchLocValue(null);
    setSearchstatusValue(null);
    setSearchstatusLocValue(null);
    setSearchGradeValue(null);
    setSearchGradeSerValue(null);
    setSearchValue('');
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
    setPageNo(1);
  }
  const getApplicationRow = (id) => {
    return manageapplicationList.find(item => item.id == id);
  }
  const handleLocationSearchInput = (v) => {

    if (v != null) {
      console.log(v.location_id);
      setSearchLocValue(v);
      setSearchstatusLocValue(null);
      setSearchValue(v.location_id);
    } else {
      setSearchLocValue(null);
      setSearchstatusLocValue(null);
      setSearchValue('');
    }
    setPageNo(1);

  }
  const handleStatusSearchInput = (v) => {

    if (v != null) {

      setSearchstatusValue(v);
      setSearchValue(v.value);
    } else {
      setSearchstatusValue(null);
      setSearchValue('');
    }
    setPageNo(1);

  }
  const handleStatusLocSearchInput = (v) => {

    if (v != null) {

      setSearchstatusLocValue(v);
    
      setFirstLoading(true);

      getApplicationList({ "pageNo": pageNo, "perPage": perPage, search_by: searchBy, search: searchValue, status_ch: v.value })

        .then(res => {
          setManagApplicationsList(res.data.data);
          setTotalCount(res.data.pagination.totalCount);
          setTotalPage(res.data.pagination.totalPage);
          setFirstLoading(false);
        });

    } else {
      setSearchstatusValue(null);
      setPageNo(1);

    }

  }
  const handleClearFilter = () => {
    document.getElementById('location_idsearch').style.display = 'none';
    document.getElementById('text_idsearch').style.display = 'block';
    document.getElementById('status_idsearch').style.display = 'none';
    setSearchValue('');
    setSearchLocValue(null);
    setSearchstatusValue(null);
    setSearchstatusLocValue(null);
    setSearchGradeValue(null);
    setSearchGradeSerValue(null);
    setSearchPlaceholder('Student ID');
    setSearchBy('stuid');
    setPageNo(1);
  }


  const handleColumnClickGr = (type) => {
    let placeholder = '';
    document.getElementById('location_idsearch').style.display = 'none';
    document.getElementById('text_idsearch').style.display = 'none';
    document.getElementById('status_idsearch').style.display = 'none';

    setSearchValue('');
    setSearchLocValue(null);
    setSearchstatusValue(null);
    setSearchstatusLocValue(null);
    setSearchGradeValue(null);
    setSearchGradeSerValue(null);
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
    setPageNo(1);
  }
  const handleAutocompleteGradeChange = (type, value) => {
    if (value != null) {
      setSearchGradeValue(value);
      setSearchGradeSerValue(null);
      setSearchValue(value.value);
    }
    else {
      setSearchGradeValue(null);
      setSearchGradeSerValue(null);
      setSearchValue('');
    }
    setPageNo(1);
  }

  const handleAutocompleteGradeSerChange = (type, value) => {
    if (value != null) {
      setSearchGradeSerValue(value);
      setSearchValue(value.value);
    }
    else {
      setSearchGradeSerValue(null);
      setSearchValue('');
    }
    setPageNo(1);
  }
  const [reason, setReason] = React.useState(false)
  const [reasondeatils, setReasonDeatils] = React.useState('');
  const handlereason = (consent_form) => {
    setReasonDeatils(consent_form);
    setReason(true);
  }
  const handleCloselogss = () => setReason(false);

  return (
    <>
      <Typography paragraph>


        <div className='row'>
          <div className='col-md-12'>
            <div className='club-sec application-sec'>
              <div className='container-fluid '>

                <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec admin-top-sec new-opps'>
                  <div className='row'>
                    {/* <div className='col-md-10'>
                 
                    </div> */}
                    <div className='col-md-12 main-sccc'>
                      <div className='clear-filt'>
                        <button class="btn btn-login btn-submit bt-forms btn-clear" type='button' onClick={handleClearFilter}><span className='clear-span'><FilterListIcon /></span>Clear Filter</button>
                      </div>
                      <div className='indicate-secss'>
                        <p className='style-new'><span className='square-sec'></span>All Forms Uploaded</p>
                        <p><span className='square-sec-red'></span>Partial Forms Uploaded</p>
                      </div>

                    </div>
                  </div>
                  <div className='mage-new-app-tol'>
                  {manageapplicationList.length > 0 ?
                        <p class="total-user right-user tot-app mng-app  new-app-list" style={{ marginTop: '0px' }}>Total Applications <span className='coun-col'>{totalCount}</span></p>
                        : null}
                  </div>
                  <div className='row margn-tp-mange-usr'>

                    <div class="col-sm-3"  >
                      <div class="sorting-e-form sortmng" style={{ marginTop: '0px' }}>
                        <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                          <select className='selee-sort' onChange={perPageChange} value={perPage} >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>

                        </label>
                      </div>
                    </div>
                    {/* <div class="col-md-4">

                      {manageapplicationList.length > 0 ?
                        <p class="total-user right-user tot-app mng-app" style={{ marginTop: '0px' }}>Total Applications <span className='coun-col'>{totalCount}</span></p>
                        : null}


                    </div> */}


                    <div className='col-md-9'>

                      <div className='filtr-sec'>

                        <div className='select-sec-newss admn-selct-sec  two-filter-new-secss' id="location_idsearch">
                         
                        <div className='schol-filt-twos'>
                               {searchBy == 'location' && (searchLocValue !== null && searchLocValue !== undefined && searchLocValue != '')
                            &&
                            <>
                              <Stack spacing={3} sx={{ width: '90%', margin: '0 auto' }}>
                                <Autocomplete

                                  id="tags-standard"
                                  value={searchstatusLocValue}
                                  options={sttausList}
                                  getOptionLabel={(option) => option.lable}
                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                  onChange={(e, v) => handleStatusLocSearchInput(v)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      label="Select Status"
                                      placeholder="Status"
                                    />
                                  )}
                                  renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={option.id}>
                                        {option.lable}
                                      </li>
                                    );
                                  }}
                                  renderTags={(tagValue, getTagProps) => {
                                    return tagValue.map((option, index) => (
                                      <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
                                    ))
                                  }}
                                />
                              </Stack>
                            </>


                          }
                               </div>
                          <div className='schol-filt-two'>
                          <Stack spacing={3} sx={{ width: '90%', margin: '0 auto' }}>
                            <Autocomplete

                              id="tags-standard"
                              value={searchLocValue}
                              options={locations}
                              getOptionLabel={(option) => option.locationName}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(e, v) => handleLocationSearchInput(v)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Select Location"
                                  placeholder="Location"
                                />
                              )}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option.id}>
                                    {option.locationName}
                                  </li>
                                );
                              }}
                              renderTags={(tagValue, getTagProps) => {
                                return tagValue.map((option, index) => (
                                  <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                                ))
                              }}
                            />
                          </Stack>
                          </div>
                          
                         
                               
                         

                        </div>

                        <div className='select-sec-newss admn-selct-sec' id="status_idsearch">
                          <Stack spacing={3} sx={{ width: '90%', margin: '0 auto' }}>
                            <Autocomplete

                              id="tags-standard"
                              value={searchstatusValue}
                              options={sttausList}
                              getOptionLabel={(option) => option.lable}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                              onChange={(e, v) => handleStatusSearchInput(v)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Select Status"
                                  placeholder="Status"
                                />
                              )}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option.id}>
                                    {option.lable}
                                  </li>
                                );
                              }}
                              renderTags={(tagValue, getTagProps) => {
                                return tagValue.map((option, index) => (
                                  <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
                                ))
                              }}
                            />
                          </Stack>

                        </div>

                        <div className="text-fld-sec appl_status_list adm-usr" id="text_idsearch">
                          <input type="text" className='inpt-sec' placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} />
                          <span className='search-sec'><SearchIcon /></span>
                        </div>


                        {searchBy == 'grade_ch'
                          ?
                          <>
                            <div className='admn-selct-sec filtr-nwe-sec two-filter-new-sec '>





                            <div className='schol-filt-twos'>

{(searchGradeValue !== null && searchGradeValue !== undefined && searchGradeValue != '')
  &&
  <>
    {searchGradeValue.value == 'High School' &&
      <>
        <Autocomplete
          id="tags-standard"
          value={searchGradeSerValue || null}
          options={GradeHighList}
          getOptionLabel={(option) => option.lable}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event, newValue) => {
            handleAutocompleteGradeSerChange('grade_ch', newValue); 
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="School Grade"
            />
          )}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.lable}
              </li>
            );
          }}
          renderTags={(tagValue, getTagProps) => {
            return tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
            ))
          }}
        />
      </>
    }



    {searchGradeValue.value == 'Middle School' &&
      <>
        <Autocomplete
          id="tags-standard"
          value={searchGradeSerValue || null}
          options={GradeMiddleList}
          getOptionLabel={(option) => option.lable}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event, newValue) => {
            handleAutocompleteGradeSerChange('grade_ch', newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="School Grade"
            />
          )}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.lable}
              </li>
            );
          }}
          renderTags={(tagValue, getTagProps) => {
            return tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
            ))
          }}
        />
      </>
    }


    {searchGradeValue.value == 'Primary School' &&
      <>
        <Autocomplete
          id="tags-standard"
          value={searchGradeSerValue || null}
          options={GradePrimaryList}
          getOptionLabel={(option) => option.lable}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event, newValue) => {
            handleAutocompleteGradeSerChange('grade_ch', newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="School Grade"
            />
          )}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.lable}
              </li>
            );
          }}
          renderTags={(tagValue, getTagProps) => {
            return tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
            ))
          }}
        />
      </>
    }

  </>




}
                                </div>
                              
                              <div className='schol-filt-two'>

                              <Autocomplete
                                id="tags-standard"
                                value={searchGradeValue || null}
                                options={GradeList}
                                getOptionLabel={(option) => option.lable}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => {
                                  handleAutocompleteGradeChange('grade_ch', newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="School Type"
                                  />
                                )}
                                renderOption={(props, option) => {
                                  return (
                                    <li {...props} key={option.id}>
                                      {option.lable}
                                    </li>
                                  );
                                }}
                                renderTags={(tagValue, getTagProps) => {
                                  return tagValue.map((option, index) => (
                                    <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
                                  ))
                                }}
                              />

                              </div>
                           
                            



                            </div>

                          </>
                          :
                          <>

                          </>
                        }
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12'>
                      <table class="table table-bordered">
                        <thead class="thead-light thead-travel thead-form">
                          <tr>

                            <th className='std-id-width adm-lst-id new-st-app-lis' onClick={() => handleColumnClick('student_id')} role='button'>Student ID <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                            <th className='loc-width adm-lst-loc' onClick={() => handleColumnClick('location')} role='button'>Location <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                            <th className='std-name-width adm-lst-name' onClick={() => handleColumnClick('student_name')} role='button'>Student Name <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                            <th className='grade-width adm-lst-grd' onClick={() => handleColumnClickGr('grade_ch')} role='button'>Grade <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                            <th className='date-width adm-lst-frm new-pare-app-lis'>Parent Consent Form</th>
                            <th className='date-width adm-plst-frm'>Physician Form</th>
                            <th className='grade-width adm-updt' >Updated By</th>
                            <th className='stts-width adm-sts neststch new-sttau-app-lis' onClick={() => handleColumnClick('status')}>Status <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                            {/* <th className='action-width'>Action</th> */}
                          </tr>
                        </thead>
                        <tbody className='tbody-light tbody-form'>
                          {
                            firstLoading ? <tr ><td colSpan={8}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                              {manageapplicationList.length > 0 ?

                                manageapplicationList.map((userd, index) =>
                                  <tr key={index}>
                                    <td className='std-id'>{userd.stuid}</td>
                                    <td>

                                      {userd.school_name}

                                    </td>
                                    <td>{userd.student_name} {userd.last_name}</td>
                                    <td>

                                      {userd.stu_grade}


                                    </td>
                                    <td><p className='form-comp'>
                                      {userd.document_details.length > 0 && userd.document_details.length}

                                      <span className={` ${(userd.pending_parent_form != 0) && 'red-down'} ${(userd.pending_parent_form == 0) && 'blue-down'}`}>
                                        <a title="Download"><DownloadIcon onClick={() => handleDownloadFile(userd.id)} /></a></span></p>
                                      {
                                        userd.pending_parent_form != 0 ? <p className='form-pend'>{userd.pending_parent_form} Form Pending</p> : null
                                      }
                                    </td>
                                    <td>

                                      {userd.physician_document_details.length > 0 &&
                                        <>
                                          <p className='form-comp'>
                                            {userd.physician_document_details.length}
                                            <span className={` ${(userd.physician_document_details.length < 2) && 'red-down'} ${(userd.physician_document_details.length == 2) && 'blue-down'}`}>
                                              <a title="Download"><DownloadIcon onClick={() => handlePhysicianDownloadFile(userd.id)} /></a></span></p>


                                          {
                                            (userd.physician_document_details.length != 0 && userd.physician_document_details.length > 2) ? <p className='form-pend'>{(2 - userd.physician_document_details.length)} Physician Form Pending</p> : null
                                          }
                                        </>
                                      }



                                      {/* {
                                          userd.physician_document_details.length ?
                                            <div>
                                             <p className='form-pend'>{(2 - userd.physician_document_details.length)} Form Pending</p>
                                              <ul className='list-group'>
                                                {
                                                  userd.physician_document_details.map((item, index2) => (
                                                    <li className='list-group-item psycn-form-link' key={index2}>
                                                      <span className="blue-down">
                                                        <a title="Download" ><DownloadIcon className='download_icon' onClick={() => handleDownload(item.document)} />
                                                        </a></span> {truncateString(item.document, 35)}
                                                      
                                                    </li>
                                                  ))
                                                }

                                              </ul>
                                            </div> : null
                                        } */}
                                    </td>
                                    <td>
                                      {userd.nurse_details != null && <>
                                        {userd.nurse_details.name} {userd.nurse_details.last_name}
                                      </>}
                                    </td>
                                    {/*<td className='std-id' onClick={() => handleFormStatusCheck(userd)}><CheckIcon /></td>*/}
                                    <td>
                                      <div className='round-stss'>

                                        <span className=
                                          {`green-down ${(userd.consent_details.status == 'Rejected') ? 'square-sec-redss new-round-red' : (userd.consent_details.status == 'Pending' ? 'pend-sts round-pend' : 'round-approve')}`} style={{ fontWeight: '700', fontSize: '17px' }}>
                                          {(userd.consent_details.status == 'Rejected') && 'R'}
                                          {(userd.consent_details.status == 'Pending') && 'P'}
                                          {(userd.consent_details.status == 'Approved') && 'A'}</span>

                                        {(userd.consent_details.status == 'Approved' || userd.consent_details.status == 'Rejected') &&
                                          <>
                                            {userd.consent_details.reason != '' && userd.consent_details.reason != null &&
                                              <div className='stst-visi'>
                                                <span className='visib-sec'
                                                  onClick={() => handlereason(userd.consent_details)}><VisibilityIcon /></span></div>

                                            }
                                          </>
                                        }
                                      </div>
                                    </td>


                                  </tr>
                                )

                                : <tr><td colSpan={8}>No Data Found</td></tr>}
                            </>
                          }

                        </tbody>
                      </table>
                      {totalPage > 1 ? <>
                        <div className="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                          <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                            <div className="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                              <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {pageNo} of {totalPage}</p>
                            </div>
                            <div className="pagin-sec">
                              <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={(e) => changePage(pageNo - 1)}></i>
                              <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#626262" }}>Go to </span>
                              <input type="number"
                                value={pageNo} onChange={(e) => {
                                  !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                }}
                                style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "6px 6px 0px 4px", fontSize: "14px", width: "34px", float: "left", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }} />

                              <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={(e) => changePage(pageNo + 1)}></i>
                            </div>
                          </div>

                        </div>
                      </> : ''
                      }

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </Typography>


      <BootstrapDialog
        onClose={handleCloselogss}
        aria-labelledby="customized-dialog-title"
        open={reason} className="route-view copy-view logout-view login-modal app-modal resn-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}>
              {reasondeatils != null && reasondeatils != '' &&
                <>
                  {
                    reasondeatils.status == 'Approved' ?
                      <h2 className='uplod-secddd'>Approval Feedback</h2>
                      :
                      <h2 className='uplod-secddd'>Reason For Rejection</h2>
                  }
                  <p className='uplod-para approv-fed'>{reasondeatils.reason}</p>
                </>
              }

            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
}
export default ApplicationList;

